import conformToMask from 'text-mask-core/src/conformToMask';

import unmask from './unmask';
import createMask, { Masks, CreateNumberMaskProps, strToMask, CurrencyConfig } from './mask';

const mask = createMask(conformToMask);

export { mask, Masks, unmask, strToMask, CreateNumberMaskProps, CurrencyConfig };
